import { useEffect, useRef } from 'react'

// Returns the previous value of a given state variable,
// starting with an initial value of undefined
const usePreviousValue = <T,>(value: T): T | undefined => {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}

export default usePreviousValue
